<div class="card block isMinimizable">
    <div class="card-header">
        <div class="card-title">
            <i class="fa fa-angle-up"></i>
            <h2>Charges annuelles</h2>
        </div>
    </div>
    <div class="card-body col-md-12">
        <img *ngIf="preview" src="assets/widgets/ss_charges.PNG" class="img-fluid" />
        <div class="card-text row" *ngIf="!preview">
            <table>
                <tr>
                    <th>Taxe foncière</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Taxe foncière</mat-label>
                            <input matInput [(ngModel)]="favorite.amount_property_tax" (ngModelChange)="edit($event)">
                            <span matSuffix>€/an</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Assurance PNO</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Assurance PNO</mat-label>
                            <input matInput [(ngModel)]="favorite.building_insurance" (ngModelChange)="edit($event)">
                            <span matSuffix>€/an</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Gestion agence</th>
                    <td>
                        <mat-form-field appearance="standard" class="percent_value">
                            <mat-label>Taux frais de gestion</mat-label>
                            <input matInput [(ngModel)]="favorite.agence" (ngModelChange)="edit($event)">
                            <span matSuffix>%</span>
                        </mat-form-field>
                        <span class="d-none d-md-block">
                            {{ (favorite.amount_rent - (favorite.amount_rent + favorite.amount_copro_rent) * favorite.rental_vacancy / 12 + favorite.amount_copro_rent) * favorite.agence / 100 * 12 |number:'1.0-1'}} €/an
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>Frais de relocation</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Frais de relocation</mat-label>
                            <input matInput [(ngModel)]="favorite.agence_rental" (ngModelChange)="edit($event)">
                            <span matSuffix>€/an</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Garantie loyers impayés</th>
                    <td>
                        <mat-form-field appearance="standard" class="percent_value">
                            <mat-label>Garantie loyers impayés</mat-label>
                            <input matInput [(ngModel)]="favorite.amount_rent_insurance" (ngModelChange)="edit($event)">
                            <span matSuffix>%</span>
                        </mat-form-field>
                        <span class="d-none d-md-block">
                            {{ favorite.amount_rent * favorite.amount_rent_insurance / 100 * 12 |number:'1.0-1'}} €/an
                        </span>
                    </td>
                </tr>
                <tr>
                    <th>Charges de copropriété propriétaire</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Charge de copropriété propriétaire</mat-label>
                            <input matInput [(ngModel)]="favorite.amount_copro" (ngModelChange)="edit($event)">
                            <span matSuffix>€/an</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Vacance locative</th>
                    <td>

                        <mat-form-field appearance="standard" class="percent_value">
                            <mat-label>Garantie loyers impayés</mat-label>
                            <input matInput [(ngModel)]="favorite.rental_vacancy" (ngModelChange)="edit($event)">
                            <span matSuffix>mois</span>
                        </mat-form-field>

                        {{ (favorite.amount_rent + favorite.amount_copro_rent) * favorite.rental_vacancy |number:'1.0-0'}} €/an
                    </td>
                </tr>
                <tr>
                    <th>Autres frais</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Autres frais</mat-label>
                            <input matInput [(ngModel)]="favorite.other_bill" (ngModelChange)="edit($event)">
                            <span matSuffix>€/an</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Comptabilité</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>Comptabilité</mat-label>
                            <input matInput [(ngModel)]="favorite.accouting_fees" (ngModelChange)="edit($event)">
                            <span matSuffix>€/an</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>CGA</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>CGA</mat-label>
                            <input matInput [(ngModel)]="favorite.cga_contribution" (ngModelChange)="edit($event)">
                            <span matSuffix>€/an</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>CFE</th>
                    <td>
                        <mat-form-field appearance="standard">
                            <mat-label>CFE</mat-label>
                            <input matInput [(ngModel)]="favorite.cfe_contribution" (ngModelChange)="edit($event)">
                            <span matSuffix>€/an</span>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th>Total</th>
                    <td>
                        {{ favorite.charge * 12 | number: '1.0-0' }} €/an
                    </td>
                </tr>
            </table>
        </div>
    </div>
</div>
